import React from 'react'
import bn from "../../../utils/bemnames"
import {
  findEventCompetitorByPosition,
  isInNextHours,
  unknownEventScoreString
} from '../../../utils/event'
import {Outcomes} from '../../../utils/outcome'
import {_t} from '../../../utils/translations'
import {
  EventPositions,
  EventStatus,
  IWidgetBackground,
  IWidgetProvider,
  oddsFormats
} from '../../../utils/types'
import {isItalianMarket} from "../../../utils/regions"
import {isItalianOddsAvailable} from "../../../utils/odds"
import {
  IEventBannerDataResponse,
  IFallbackClientAffiliateLink
} from '../../../api/match-center'
import moment from "moment"
import CountdownTimer from '../../CountdownTimer'
import CountUpTimer from '../../CountUpTimer'
import Breadcrumbs from './Breadcrumbs'
import CompetitorLastResultsBar from './CompetitorLastResultsBar'
import EventCompetitor from './EventCompetitor'
import OddsButtonWithOperatorLogoAndOutcome from "../../Buttons/OddsButtonWithOperatorLogoAndOutcome"
import EventBannerTitle from "./EventBannerTitle"
import Odds from "../../Standings/Odds"
import {useGlobalState} from "../../../contexts/GlobalState"
import {
  getBannerBgStyles,
  findOdds,
  findOddsInOtherOddsByPromotedProvider
} from "../../../utils/competitors";


const bem = bn.create('event-top-banner-four-competitors')

interface IProps {
  eventBannerData: IEventBannerDataResponse
  isMobile: boolean
  backgrounds: null | IWidgetBackground[]
  widgetId: number
  outLinkFolder: string | null
  builderComponentId: number
  allowedProviders: IWidgetProvider[] | null
  oddsFormat: oddsFormats
  fallbackClientAffiliateLinks: IFallbackClientAffiliateLink[]
  showLinks: boolean
  eventType: string
}

const EventTopBannerFourCompetitors: React.FC<IProps> = (props) => {
  const {
    eventBannerData,
    isMobile,
    backgrounds,
    oddsFormat,
    builderComponentId,
    outLinkFolder,
    widgetId,
    allowedProviders,
    fallbackClientAffiliateLinks,
    showLinks,
    eventType
  } = props

  const {globalState} = useGlobalState()

  return (
    <div className={bem.b('')}>
      <div className={`${bem.e('title')} ${isMobile ? bem.e('title-mobile') : ''}`}>
        <EventBannerTitle
          className={`${bem.e('title-text')} ${isMobile ? bem.e('title-text-mobile') : ''}`}
          tournamentName={eventBannerData.tournamentStage.name}
        />
      </div>
      <div className={bem.e('breadcrumbs')}>
        <Breadcrumbs />
      </div>
      {/* Live event stripe */}
      {eventBannerData.status === EventStatus.Inprogress &&
        <div className={bem.e('status')}>
          <div className={bem.e('status-text')}>
            {_t('Live')}
            <span>{eventBannerData.gameMoment}</span>
          </div>
        </div>
      }
      <div
        className={bem.e('background')}
        style={getBannerBgStyles(eventBannerData.tournamentStage.tournament.competition.sport!, globalState.promotedProvider, backgrounds)}
      >
        <div className={bem.e('container')}>
          <div className={`${bem.e('row')} ${isMobile ? bem.e('row-mobile') : ''}`}>
            {isMobile && (
              <div className={`${bem.e('column-mobile')} ${bem.e('column-center')}`}>
                <div className={`${bem.e('score')} ${isMobile ? bem.e('score-mobile') : ''}`}>
                  {eventBannerData.status === EventStatus.NotStarted && (
                    <>
                      {isInNextHours(eventBannerData.userStartTime, 2) ? (
                        <div className={bem.e('event-date')}>
                          <CountdownTimer
                            eventDate={eventBannerData.userStartTime}
                            isMobile={isMobile}
                          />
                        </div>
                      ) : (
                        <div
                          className={bem.e(`${isMobile ? 'event-date-time--mobile' : 'event-date-time'}`)}
                        >
                         <span
                           className={bem.e(`${isMobile ? 'event-date--mobile' : 'event-date'}`)}
                         >
                          {eventBannerData.userStartTime && moment(eventBannerData.userStartTime).format("DD-MM-YYYY")}
                        </span>
                          <span
                            className={bem.e(`${isMobile ? 'event-time--mobile' : 'event-time'}`)}
                          >
                          {eventBannerData.userStartTime && moment(eventBannerData.userStartTime).format("HH:mm")}
                        </span>
                        </div>
                      )}
                    </>
                  )}
                  {eventBannerData.status === EventStatus.Inprogress && (
                    <div className={bem.e('event-date')}>
                      <CountUpTimer
                        eventDate={eventBannerData.userStartTime}
                        isMobile={isMobile}
                      />
                    </div>
                  )}
                  {eventBannerData.status === EventStatus.Finished && (
                    <div className={bem.e(`${isMobile ? 'event-date--mobile' : 'event-date'}`)}>
                      Finished
                    </div>
                  )}
                  {[
                    EventStatus.Interrupted,
                    EventStatus.Cancelled,
                    EventStatus.Postponed,
                    EventStatus.Deleted,
                    EventStatus.Unknown,
                  ].includes(eventBannerData.status) && (
                    <span> {unknownEventScoreString} </span>
                  )}
                </div>
              </div>
            )}
            <div className={`${bem.e('column')} ${isMobile ? bem.e('column-mobile') : ''}`}>
              <EventCompetitor
                eventType={eventType}
                eventCompetitor={findEventCompetitorByPosition(eventBannerData.eventCompetitors, EventPositions.home)}
                sportId={eventBannerData.tournamentStage.tournament.competition.sportId}
                isMobile={isMobile}
              />
              {EventPositions.homeSecond && (
                <EventCompetitor
                  eventType={eventType}
                  eventCompetitor={findEventCompetitorByPosition(eventBannerData.eventCompetitors, EventPositions.homeSecond)}
                  sportId={eventBannerData.tournamentStage.tournament.competition.sportId}
                  isMobile={isMobile}
                />
              )}
              <div className={`${bem.e('outcome-line')} ${bem.m('align-home')} ${isMobile ? bem.e('outcome-line--mobile') : ''}`}>
                {!(isItalianMarket(globalState.widget?.client.regionIds) && !isItalianOddsAvailable(eventBannerData.maxOdds)) && _t('to WIN')}
              </div>
            </div>
            {isMobile && (
              <div className={bem.e('vs')}>vs</div>
            )}
            {!isMobile && (
              <div className={`${bem.e('column')} ${bem.e('column-center')}`}>
                <div className={bem.e('score')}>
                  {eventBannerData.status === EventStatus.NotStarted && (
                    <>
                      {isInNextHours(eventBannerData.userStartTime, 2) ? (
                        <div className={bem.e('event-date')}>
                          <CountdownTimer
                            eventDate={eventBannerData.userStartTime}
                            isMobile={isMobile}
                          />
                        </div>
                      ) : (
                        <div
                          className={bem.e(`${isMobile ? 'event-date-time--mobile' : 'event-date-time'}`)}
                        >
                         <span
                           className={bem.e(`${isMobile ? 'event-date--mobile' : 'event-date'}`)}
                         >
                          {eventBannerData.userStartTime && moment(eventBannerData.userStartTime).format("DD-MM-YYYY")}
                        </span>
                          <span
                            className={bem.e(`${isMobile ? 'event-time--mobile' : 'event-time'}`)}
                          >
                          {eventBannerData.userStartTime && moment(eventBannerData.userStartTime).format("HH:mm")}
                        </span>
                        </div>
                      )}
                    </>
                  )}
                  {eventBannerData.status === EventStatus.Inprogress && (
                    <div className={bem.e('event-date')}>
                      <CountUpTimer
                        eventDate={eventBannerData.userStartTime}
                        isMobile={isMobile}
                      />
                    </div>
                  )}
                  {eventBannerData.status === EventStatus.Finished && (
                    <div className={bem.e(`${isMobile ? 'event-date--mobile' : 'event-date'}`)}>
                      _t('Finished')
                    </div>
                  )}
                  {[
                    EventStatus.Interrupted,
                    EventStatus.Cancelled,
                    EventStatus.Postponed,
                    EventStatus.Deleted,
                    EventStatus.Unknown,
                  ].includes(eventBannerData.status) && (
                    <span> {unknownEventScoreString} </span>
                  )}
                </div>
              </div>
            )}
            <div className={`${bem.e('column')}${isMobile ? bem.e('column-mobile') : ''}`}>
              <EventCompetitor
                eventType={eventType}
                eventCompetitor={findEventCompetitorByPosition(eventBannerData.eventCompetitors, EventPositions.away)}
                sportId={eventBannerData.tournamentStage.tournament.competition.sportId}
                isMobile={isMobile}
              />
              {EventPositions.awaySecond && (
                <EventCompetitor
                  eventType={eventType}
                  eventCompetitor={findEventCompetitorByPosition(eventBannerData.eventCompetitors, EventPositions.awaySecond)}
                  sportId={eventBannerData.tournamentStage.tournament.competition.sportId}
                  isMobile={isMobile}
                />
              )}
              <div className={`${bem.e('outcome-line')} ${bem.m('align-away')} ${isMobile ? bem.e('outcome-line--mobile') : ''}`}>
                {!(isItalianMarket(globalState.widget?.client.regionIds) && !isItalianOddsAvailable(eventBannerData.maxOdds)) && _t('to WIN')}
              </div>
            </div>
          </div>
          <div className={`${bem.e('row')} ${isMobile ? bem.e('row-mobile') : ''}`}>
            <div className={`${bem.e('column')} ${isMobile ? bem.e('column-mobile') : ''}`}>
              <div className={`${bem.e('information-line')} ${bem.e('information-line--home')} ${isMobile ? `${bem.e('information-line--mobile')} ${bem.e('information-line--reverse')}` : ''}`}>
                <div
                  className={`${bem.e('information-line__item')} ${isMobile ? bem.e('information-line__item--mobile') : ''}`}
                >
                  <div className={bem.e('competitor-last-results-bar')}>
                    <CompetitorLastResultsBar
                      meetingResults={
                        findEventCompetitorByPosition(eventBannerData.eventCompetitors, EventPositions.home)?.prevMeetings?.sort((a, b) => Date.parse(a.userStartTime) - Date.parse(b.userStartTime)).map(prevMeeting => prevMeeting.meetingResult) ?? []
                      }
                      isMobile={isMobile}
                    />
                  </div>
                </div>
                <div className={bem.e('information-line__item')}>
                  {(isItalianMarket(globalState.widget?.client.regionIds) && !isItalianOddsAvailable(eventBannerData.maxOdds)) ?
                    <></>
                    : (globalState.promotedProvider !== null && findOdds(eventBannerData.maxOdds, Outcomes.OUTCOME_1, globalState.promotedProvider) === null ? (
                        <>
                          {findOddsInOtherOddsByPromotedProvider(eventBannerData.maxOdds, Outcomes.OUTCOME_1, globalState.promotedProvider) ? <OddsButtonWithOperatorLogoAndOutcome
                            oddsLine={findOddsInOtherOddsByPromotedProvider(eventBannerData.maxOdds, Outcomes.OUTCOME_1, globalState.promotedProvider)?.odds ?? null}
                            widgetId={widgetId}
                            outLinkFolder={outLinkFolder}
                            eventId={eventBannerData.id}
                            builderComponentId={builderComponentId}
                            provider={findOddsInOtherOddsByPromotedProvider(eventBannerData.maxOdds, Outcomes.OUTCOME_1, globalState.promotedProvider)?.provider ?? null}
                            outcome={Outcomes.OUTCOME_1}
                            oddsFormat={oddsFormat}
                            fallbackClientAffiliateLinks={fallbackClientAffiliateLinks}
                            isMobile={isMobile}
                            eventStatus={eventBannerData.status}
                            oddsPrev={null}
                          /> : <Odds
                            odds={null}
                            direction={null}
                            arrow={false}
                            provider={globalState.promotedProvider.provider}
                          />}
                        </>
                      ) : (showLinks && allowedProviders && eventBannerData.maxOdds.length > 0 && findOdds(eventBannerData.maxOdds, Outcomes.OUTCOME_1, globalState.promotedProvider) !== null) ?
                        <OddsButtonWithOperatorLogoAndOutcome
                          oddsLine={findOdds(eventBannerData.maxOdds, Outcomes.OUTCOME_1, globalState.promotedProvider)?.odds ?? null}
                          widgetId={widgetId}
                          outLinkFolder={outLinkFolder}
                          eventId={eventBannerData.id}
                          builderComponentId={builderComponentId}
                          provider={findOdds(eventBannerData.maxOdds, Outcomes.OUTCOME_1, globalState.promotedProvider)?.provider ?? null}
                          outcome={Outcomes.OUTCOME_1}
                          oddsFormat={oddsFormat}
                          fallbackClientAffiliateLinks={fallbackClientAffiliateLinks}
                          isMobile={isMobile}
                          eventStatus={eventBannerData.status}
                          oddsPrev={findOdds(eventBannerData.maxOdds, Outcomes.OUTCOME_1, globalState.promotedProvider)?.oddsPrev ?? null}
                        /> : (globalState.promotedProvider && <Odds
                          odds={null}
                          direction={null}
                          arrow={false}
                          provider={globalState.promotedProvider.provider}
                        />)
                    )}
                </div>
              </div>
            </div>
            <div className={`${bem.e('column')} ${bem.e('column-center')} ${isMobile ? bem.e('column-mobile') : ''}`}>

            </div>
            <div className={`${bem.e('column')} ${isMobile ? bem.e('column-mobile') : ''}`}>
              <div
                className={`${bem.e('information-line')} ${bem.e('information-line--away')} ${isMobile ? bem.e('information-line--mobile') : ''}`}>
                <div
                  className={`${bem.e('information-line__item')} ${isMobile ? bem.e('information-line__item--mobile') : ''}`}
                >
                  {(isItalianMarket(globalState.widget?.client.regionIds) && !isItalianOddsAvailable(eventBannerData.maxOdds)) ?
                    <></>
                    : (globalState.promotedProvider !== null && findOdds(eventBannerData.maxOdds, Outcomes.OUTCOME_2, globalState.promotedProvider) === null ? (
                      <>
                        {findOddsInOtherOddsByPromotedProvider(eventBannerData.maxOdds, Outcomes.OUTCOME_2, globalState.promotedProvider) ? (
                          <OddsButtonWithOperatorLogoAndOutcome
                            oddsLine={findOddsInOtherOddsByPromotedProvider(eventBannerData.maxOdds, Outcomes.OUTCOME_2, globalState.promotedProvider)?.odds ?? null}
                            widgetId={widgetId}
                            outLinkFolder={outLinkFolder}
                            eventId={eventBannerData.id}
                            builderComponentId={builderComponentId}
                            provider={findOddsInOtherOddsByPromotedProvider(eventBannerData.maxOdds, Outcomes.OUTCOME_2, globalState.promotedProvider)?.provider ?? null}
                            outcome={Outcomes.OUTCOME_2}
                            oddsFormat={oddsFormat}
                            fallbackClientAffiliateLinks={fallbackClientAffiliateLinks}
                            isMobile={isMobile}
                            eventStatus={eventBannerData.status}
                            oddsPrev={null}
                          />
                        ) : (
                          <Odds
                            odds={null}
                            direction={null}
                            arrow={false}
                            provider={globalState.promotedProvider.provider}
                          />
                        )}
                      </>
                    ) : (showLinks &&
                        allowedProviders &&
                        eventBannerData.maxOdds.length > 0 &&
                        findOdds(eventBannerData.maxOdds, Outcomes.OUTCOME_2, globalState.promotedProvider) !== null) ? (
                          <OddsButtonWithOperatorLogoAndOutcome
                            oddsLine={findOdds(eventBannerData.maxOdds, Outcomes.OUTCOME_2, globalState.promotedProvider)?.odds ?? null}
                            widgetId={widgetId}
                            outLinkFolder={outLinkFolder}
                            eventId={eventBannerData.id}
                            builderComponentId={builderComponentId}
                            provider={findOdds(eventBannerData.maxOdds, Outcomes.OUTCOME_2, globalState.promotedProvider)?.provider ?? null}
                            outcome={Outcomes.OUTCOME_2}
                            oddsFormat={oddsFormat}
                            fallbackClientAffiliateLinks={fallbackClientAffiliateLinks}
                            isMobile={isMobile}
                            eventStatus={eventBannerData.status}
                            oddsPrev={findOdds(eventBannerData.maxOdds, Outcomes.OUTCOME_2, globalState.promotedProvider)?.oddsPrev ?? null}
                          />
                      ): (
                        globalState.promotedProvider && (
                          <Odds
                            odds={null}
                            direction={null}
                            arrow={false}
                            provider={globalState.promotedProvider.provider}
                          />
                        )
                      )
                    )}
                </div>
                <div className={bem.e('information-line__item')}>
                  <div className={bem.e('competitor-last-results-bar')}>
                    <CompetitorLastResultsBar
                      meetingResults={
                        findEventCompetitorByPosition(eventBannerData.eventCompetitors, EventPositions.away)?.prevMeetings?.sort((a, b) => Date.parse(a.userStartTime) - Date.parse(b.userStartTime)).map(prevMeeting => prevMeeting.meetingResult) ?? []
                      }
                      isMobile={isMobile}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EventTopBannerFourCompetitors;
